import ageAnswerReducer from './age-answerReducer';

export * from './age-answerActions';
export default ageAnswerReducer;
